var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"content pa-0",attrs:{"fluid":""}},[(_vm.admin)?_c('v-row',{class:{
      'mx-16': _vm.$vuetify.breakpoint.mdAndUp,
      'mx-6': _vm.$vuetify.breakpoint.smAndDown,
      'my-8': _vm.$vuetify.breakpoint.mdAndUp,
      'my-2': _vm.$vuetify.breakpoint.smAndDown
    }},[_c('v-spacer'),_c('v-card',{staticClass:"pa-5",attrs:{"elevation":"6","width":"90%"}},[_c('tinyMCE',{attrs:{"init":{
          content_css: false,
          skin: false,
          setup: function (ed) {
            ed.on('init', function () {
              this.getDoc().body.style.fontSize = '12';
              this.getDoc().body.style.fontFamily = 'Roboto, sans-serif';
            });
          },
          statusbar: false,
          height: 200,
          menubar: false,
          paste_as_text: true,
          language_url: '/langs/de.js',
          language: 'de',
          block_formats: 'Text=p;',
          toolbar:
            'undo redo | bold italic underline '
        }},model:{value:(_vm.home_header),callback:function ($$v) {_vm.home_header=$$v},expression:"home_header"}})],1),_c('v-spacer')],1):_vm._e(),(!_vm.admin && _vm.carouselTextItems.length)?_c('v-row',{attrs:{"no-gutters":""}},[_c('div',{staticClass:"carouselHolder"},[_c('VueSlickCarousel',{attrs:{"arrows":false,"fade":true,"infinite":true,"speed":3000,"autoplay-speed":5000,"autoplay":true}},[_vm._l((_vm.carouselTextItems),function(item){return _c('div',{key:item,class:{
            'carouselDiv': true,
            'smallCarousel': _vm.$vuetify.breakpoint.mdAndDown,
            'largeCarousel': _vm.$vuetify.breakpoint.lgOnly,
            'xlCarousel': _vm.$vuetify.breakpoint.xlOnly
          }},[_vm._v(" "+_vm._s(item)+" ")])}),_vm._v(" /> ")],2)],1)]):_vm._e(),_c('div',{staticClass:"d-flex max3Columns flex-wrap justify-space-around mx-auto"},_vm._l((_vm.homeItems),function(item,key){return _c('StartseiteCard',{key:key,staticClass:"mb-10",class:{
        'mx-12': _vm.$vuetify.breakpoint.xlOnly,
        'mx-6': _vm.$vuetify.breakpoint.mdAndUp,
        'mx-2': _vm.$vuetify.breakpoint.smAndDown
      },attrs:{"admin":_vm.admin,"label":item.label,"link":item.link,"img-src":item.imgSrc,"title-model":item.titleModel,"bottom-text-model":item.bottomTextModel}})}),1),(_vm.admin)?_c('TheTextbausteinConfirm',{staticClass:"mt-16"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }